var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBenchmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6638_9934)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.23438 19.1341C5.23438 17.5987 7.36779 16.3541 10 16.3541C12.6322 16.3541 14.7656 17.5987 14.7656 19.1341H5.23438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99993 17.9427C11.6382 17.92 13.2613 18.259 14.7536 18.9355C14.5789 17.4923 12.5178 16.3541 9.99993 16.3541C7.48209 16.3541 5.42096 17.4923 5.24622 18.9355C6.73851 18.259 8.36163 17.92 9.99993 17.9427Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.242 8.03819C14.8854 11.6061 10.605 14.2851 7.09437 11.8316C6.41999 11.3423 5.8588 10.7136 5.44889 9.9882C5.03898 9.2628 4.78995 8.4577 4.71871 7.62755L4.08329 1.30277C4.07772 1.24738 4.08386 1.19143 4.10131 1.13857C4.11876 1.0857 4.14713 1.0371 4.18458 0.995907C4.22203 0.954714 4.26772 0.921855 4.31868 0.899461C4.36965 0.877067 4.42476 0.865639 4.48043 0.865918H15.5208C15.5765 0.865639 15.6316 0.877067 15.6825 0.899461C15.7335 0.921855 15.7792 0.954714 15.8166 0.995907C15.8541 1.0371 15.8825 1.0857 15.8999 1.13857C15.9174 1.19143 15.9235 1.24738 15.9179 1.30277L15.242 8.03819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99975 0.865918H4.48116C4.42549 0.865639 4.37038 0.877067 4.31942 0.899461C4.26845 0.921855 4.22276 0.954714 4.18531 0.995907C4.14786 1.0371 4.11949 1.0857 4.10204 1.13857C4.08459 1.19143 4.07845 1.24738 4.08402 1.30277L4.71944 7.62755C4.7904 8.4575 5.03906 9.26248 5.44855 9.98787C5.85804 10.7132 6.41878 11.3421 7.09272 11.8316C7.93982 12.4418 8.9558 12.7732 9.99975 12.78V0.865918Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.9414 7.81817C2.33226 7.59298 1.80677 7.18652 1.43569 6.65355C1.06461 6.12058 0.865777 5.4867 0.865967 4.83727V4.043C0.865967 3.83234 0.949649 3.63032 1.0986 3.48136C1.24756 3.33241 1.44958 3.24873 1.66024 3.24873H4.28133",
    stroke: "#0C5CEF",
    strokeWidth: 0.73,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0584 7.81817C17.6676 7.59298 18.1931 7.18652 18.5641 6.65355C18.9352 6.12058 19.1341 5.4867 19.1339 4.83727V4.043C19.1339 3.83234 19.0502 3.63032 18.9012 3.48136C18.7523 3.33241 18.5503 3.24873 18.3396 3.24873H15.7185",
    stroke: "#0C5CEF",
    strokeWidth: 0.73,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4374 4.00808L10.9964 5.21135H12.0838C12.1388 5.20896 12.1931 5.22366 12.2393 5.25341C12.2855 5.28316 12.3214 5.32651 12.3419 5.37749C12.3625 5.42847 12.3668 5.48457 12.3542 5.53807C12.3415 5.59157 12.3126 5.63984 12.2714 5.67624L11.3275 6.60601L11.8506 7.80711C11.8731 7.8621 11.8779 7.92275 11.8643 7.9806C11.8507 8.03845 11.8194 8.09061 11.7748 8.12982C11.7301 8.16903 11.6743 8.19332 11.6152 8.19932C11.5561 8.20531 11.4966 8.1927 11.445 8.16325L10.1813 7.4526L8.91771 8.16325C8.86612 8.19307 8.80648 8.20596 8.74719 8.20012C8.68789 8.19428 8.63192 8.16999 8.58715 8.13068C8.54237 8.09137 8.51105 8.03901 8.49759 7.98096C8.48412 7.92292 8.48919 7.86212 8.51208 7.80711L9.03515 6.60601L8.09124 5.67733C8.04965 5.64106 8.02038 5.59275 8.00749 5.5391C7.99459 5.48545 7.9987 5.42911 8.01926 5.37791C8.03981 5.3267 8.07579 5.28315 8.1222 5.25331C8.16861 5.22347 8.22316 5.2088 8.27828 5.21135H9.36574L9.92524 4.00699C9.94959 3.96003 9.9864 3.92069 10.0316 3.89326C10.0769 3.86583 10.1288 3.85138 10.1817 3.85149C10.2346 3.85161 10.2864 3.86628 10.3315 3.8939C10.3766 3.92151 10.4133 3.96102 10.4374 4.00808Z",
    fill: "white",
    stroke: "#0C5CEF",
    strokeWidth: 0.73,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 12.7799V16.3541",
    stroke: "#0C5CEF",
    strokeWidth: 0.73,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.23438 19.1341C5.23438 17.5987 7.36779 16.3541 10 16.3541C12.6322 16.3541 14.7656 17.5987 14.7656 19.1341H5.23438Z",
    stroke: "#0C5CEF",
    strokeWidth: 0.73,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.242 8.03819C14.8854 11.6061 10.605 14.2851 7.09437 11.8316C6.41999 11.3423 5.8588 10.7136 5.44889 9.9882C5.03898 9.2628 4.78995 8.4577 4.71871 7.62755L4.08329 1.30277C4.07772 1.24738 4.08386 1.19143 4.10131 1.13857C4.11876 1.0857 4.14713 1.0371 4.18458 0.995907C4.22203 0.954714 4.26772 0.921855 4.31868 0.899461C4.36965 0.877067 4.42476 0.865639 4.48043 0.865918H15.5208C15.5765 0.865639 15.6316 0.877067 15.6825 0.899461C15.7335 0.921855 15.7792 0.954714 15.8166 0.995907C15.8541 1.0371 15.8825 1.0857 15.8999 1.13857C15.9174 1.19143 15.9235 1.24738 15.9179 1.30277L15.242 8.03819Z",
    stroke: "#0C5CEF",
    strokeWidth: 0.73,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6638_9934"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenchmark);
export default __webpack_public_path__ + "static/media/benchmark.981ce9e700a9bbb8f381be3b01185801.svg";
export { ForwardRef as ReactComponent };